// src/components/BotSubmissionForm.js
import React, { useState, useEffect } from "react";
import CharacterSelect from "./CharacterSelect";
import MoveSelect from "./MoveSelect";
import LiveBots from "./LiveBots";
import CostumeSelect from "./CostumeSelect";
import StageSelect from "./StageSelect";
import StyledRadarChart from "./RadarChart";
import StatsAllocator from "./StatsAllocator";
import Validation from "./validation";
import { useUser } from "../UserContext";
import ErrorMessage from "../common/ErrorMessage";
import ConfirmationModal from "../common/ConfirmationModal";
import AlertModal from '../common/AlertModal';
import HelpingBubble from "../common/Help"; 
import { encodeSeed, decodeSeed } from "../seedUtils";
import SeedInput from "./SeedInput";
import axios from "axios"
import { useNavigate, useLocation, createPath } from 'react-router-dom';  // To handle navigation
import {API_URL} from "../../App";



const BotSubmissionForm = () => {

  const { user, setUser } = useUser();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // TODO: read seed from query and populate
  const [seed, setSeed] = useState("0"*30);


  const [selectedCharacter, setSelectedCharacter] = useState(queryParams.get("character") || "");

  const x = parseInt(queryParams.get("costume_id"), 10);
  const y = parseInt(queryParams.get("preferred_stage"), 10);

  const [selectedCostumeId, setSelectedCostumeId] = useState((x !== undefined && x !== null) ? x : null);
  const [selectedStageId, setSelectedStageId] = useState((y !== undefined && y !== null) ? x : null);

  const [selectedMoveId, setSelectedMoveId] = useState(queryParams.get("preferred_move") || -1);
  const [selectedCoach, setSelectedCoach] = useState(null);
  //const [selectedPreset, setSelectedPreset] = useState(null);

  const [costumes, setCostumes] = useState([]);
  const [tag, setTag] = useState(queryParams.get("tag") || "");
  const [isValid, setIsValid] = useState(queryParams.get("tag") !== null || false);
  const defaultStats = {
    Adaptability: 50,
    Aggressivity: 50,
    Neutral: 50,
    Offstage: 50,
    StageControl: 50,
    Creativity: 50,
    Techskill: 50,

  }
  const [stats, setStats] = useState(JSON.parse(queryParams.get("stats")) || defaultStats);

  const [characters, setCharacters] = useState([]);
  const [moves, setMoves] = useState({});
  const [liveBots, setLiveBots] = useState([]);

  const [showResultModal, setShowResultModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [resultModalMessage, setResultModalMessage] = useState('');
  const confirmationModalMessage = "Care ! You cannot modify the seed of your bot after submitting."
  const [submissionSuccess, setSubmissionSuccess] = useState(null);

  const navigate = useNavigate();

  const handleSliderChange = (stat, value) => {
    const newStats = { ...stats, [stat]: parseInt(value) };
    setStats(newStats);
    const seed = encodeSeed(selectedCharacter, selectedCostumeId, selectedStageId, selectedMoveId, newStats)
    setSeed(seed);
  };
  const handleResetStats = (e) => {
    setStats(defaultStats);
    const seed = encodeSeed(selectedCharacter, selectedCostumeId, selectedStageId, selectedMoveId, defaultStats)
    setSeed(seed);
  };


  const randomize = async () => {
    const char = characters[Math.floor(Math.random() * characters.length)]

    try {
      const {loadedCostumes, loadedMoves} = await handleCharacterSelect(char)

      const randomCostumeId = Math.floor(Math.random() * loadedCostumes.length)
      setSelectedCostumeId(randomCostumeId);
      const moveIds = Array.from(Object.values(loadedMoves))
      moveIds.push(-1)
      const randoMove = moveIds[Math.floor(Math.random() * moveIds.length)]
      setSelectedMoveId(randoMove);
      const randomStageId = Math.floor(Math.random() * 6)
      setSelectedStageId(randomStageId);

      const randomStats = {};

      Object.keys(stats).map((stat) => {
        randomStats[stat] = Math.floor(Math.random() * 100)
        return stat;
      });
      
      setStats(randomStats);

      const seed = encodeSeed(char, randomCostumeId, randomStageId, randoMove, randomStats)
      setSeed(seed);


    } catch (error) {
      //console.log(error);
    }
    
  }

  const [tagError, setTagError] = useState("");

  const char_costume = {
    "BOWSER": 4,
    "CPTFALCON": 6,
    "DK": 5,
    "DOC": 5,
    "FALCO": 4,
    "FOX": 4,
    "GANONDORF": 5,
    "POPO": 4,
    "JIGGLYPUFF": 5,
    "KIRBY": 6,
    "LINK": 5,
    "LUIGI": 4,
    "MARIO": 5,
    "MARTH": 5,
    "MEWTWO": 4,
    "GAMEANDWATCH": 4,
    "NESS": 4,
    "PEACH": 5,
    "PIKACHU": 4,
    "PICHU": 4,
    "ROY": 5,
    "SAMUS": 5,
    "YOSHI": 6,
    "YLINK": 5,
    "ZELDA": 5,
    "SHEIK": 5,
  }

  const loadCostumes = async (character) => {
    const char = character.toUpperCase()
    const n = char_costume[char] || 0; // Get the number of costumes, default to 0 if character not found

    const costumes = Array.from({ length: n }, (_, costumeId) => ({
      id: costumeId,
      src: `/splasharts/${char}_${costumeId}.webp`
    }));
    setCostumes(costumes);
    return costumes
  };

  const handleTagInput = (e) => {
    const tagValue = e.target.value.trim(); // Trim unnecessary spaces
    const error = Validation.tag(tagValue); // Validate input
    setTagError(error);
    setTag(tagValue); // Update state if valid

  };


  const handleCharacterSelectFromHUD = async (character) => {
    await handleCharacterSelect(character);
    const seed = encodeSeed(character, selectedCostumeId, selectedStageId, selectedMoveId, stats)
    //console.log(seed, character, selectedCostumeId, selectedStageId, selectedMoveId, stats);
    setSeed(seed);
  }

  // Handle character change
  const handleCharacterSelect = async (character) => {
    setSelectedCharacter(character);
    setSelectedCostumeId(null); // Reset selected costume when character changes
    setSelectedMoveId(-1);
    const loadedCostumes = await loadCostumes(character)
    const loadedMoves = await loadMoves(character)
    //loadCostumes(character); // Load costumes for the selected character
    return {loadedCostumes, loadedMoves}
  };



  // Handle character change
  const handleMoveSelect = (e) => {
    const move = e.target.value;
    setSelectedMoveId(move);
    const seed = encodeSeed(selectedCharacter, selectedCostumeId, selectedStageId, move, stats)
    setSeed(seed);
  };

  // Handle costume selection
  const handleCostumeSelect = (costumeId) => {
    setSelectedCostumeId(costumeId);
    const seed = encodeSeed(selectedCharacter, costumeId, selectedStageId, selectedMoveId, stats)
    setSeed(seed);
  };

  const handleStageSelect = (stageId) => {
    setSelectedStageId(stageId);
    const seed = encodeSeed(selectedCharacter, selectedCostumeId, stageId, selectedMoveId, stats)
    setSeed(seed);
  };

  //const handlePresetSelect = async (index) => {

    //const preset = liveBots[index];
    //setSelectedPreset(index);
    //setSelectedCharacter(preset.character);
    //setSelectedCostumeId(null);

    //setSelectedStageId(preset.preferred_stage);
    //setSelectedMoveId(preset.preferred_move);
    //setStats(preset.stats);
    //setSelectedCostumeId(preset.costume_id);

  //}

  const handleCoachSelect = async (index) => {
    setSelectedCoach(index);

  }

  useEffect(() => {
    const validateInputs = () => {
      const isTagValid = tag.length > 0;
      const isCharacterValid = selectedCharacter !== "";
      const isCostumeValid = selectedCostumeId !== null && selectedCostumeId >= 0 && selectedCostumeId < costumes.length;
      const isStageValid = selectedStageId !== null && selectedStageId >= 0 && selectedStageId < 6;

      setIsValid(isTagValid && isCharacterValid && isCostumeValid && isStageValid);
    };
    validateInputs();
  }, [tag, selectedCharacter, selectedCostumeId, selectedStageId, costumes]);

  useEffect(() => {
    // Fetch game data from the backend
    const fetchAvailableCharacters = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/available-chars`);

            setCharacters(response.data)
        } catch (error) {
            //console.error("Failed to fetch game data:", error);
        }
    };
    const fetchLiveBots = async () => {
      try {
          const response = await axios.get(`${API_URL}/api/livebots`);

          setLiveBots(response.data)
      } catch (error) {
          //console.error("Failed to fetch live bot infos:", error);
          setLiveBots([]);
      }
    };
    fetchLiveBots();
    fetchAvailableCharacters();

  }, []);

  //useEffect(() => {
  //  if (selectedCharacter) {
  //    loadCostumes(selectedCharacter)
  //    loadMoves(selectedCharacter)
  //  }
  //}, [selectedCharacter])

  const loadMoves = async (selectedCharacter) => {
    try {
      const response = await axios.get(`${API_URL}/api/available-moves/${selectedCharacter}`);

      setMoves(response.data)
      return response.data
    } catch (error) {
      //console.error("Failed to fetch game data:", error);
    }
  }



  const handleManualSeedChange = async (e) => {
    const newSeed = e;

    // Only set value if it is a valid number or an empty string
    if (/^\d*$/.test(newSeed)) {
      try {
        const {decodedSelectedCharacter, decodedSelectedCostumeId, decodedSelectedStageId, decodedSelectedMoveId, decodedStats} = decodeSeed(newSeed)
        const {loadedCostumes, loadedMoves} = await handleCharacterSelect(decodedSelectedCharacter);
        //console.log(loadedMoves)
        //console.log("hi", decodedSelectedCostumeId, loadedCostumes.length, decodedSelectedStageId, decodedStats, decodedSelectedMoveId)
        if (decodedSelectedCostumeId >= loadedCostumes.length || decodedSelectedStageId >= 6 || !Object.values(decodedStats).every(value => value >= 0 && value <= 100) ||
        !Object.values(loadedMoves).includes(decodedSelectedMoveId)) {
          throw new Error("Invalid seed!")
        }
        setSelectedCostumeId(decodedSelectedCostumeId)
        setSelectedStageId(decodedSelectedStageId)

        const decodedNamedStats = {};
        Object.keys(stats).forEach((stat, index) => {
          decodedNamedStats[stat] = decodedStats[index]
        });

        setStats(decodedNamedStats)
        setSelectedMoveId(decodedSelectedMoveId);
        setSeed(newSeed);
      } catch (error) {
        setSelectedCharacter(null);
        setSeed("0"*30);
        //console.log(error);
      }
    }

  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!isValid){
        throw new Error("Unexpected error.");
      }
      const coach_tag = (selectedCoach == null)? null: liveBots[selectedCoach].tag;
      const token = localStorage.getItem("twitchToken");
      const response = await axios.post(`${API_URL}/api/submitbot`, {
        "twitch_display_name": user.display_name,
        "twitch_user_email": user.email,
        "tag": tag,
        "costume_id": selectedCostumeId,
        "character": selectedCharacter,
        "preferred_stage": selectedStageId,
        "preferred_move": selectedMoveId,
        "stats": stats,
        "coach_tag": coach_tag
      },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setShowConfirmModal(false)
      setSubmissionSuccess(response.status===200);
      setResultModalMessage(response.data.message);
      setShowResultModal(true);
    } catch (error) {
      setShowConfirmModal(false)
      //console.log(error);
      setResultModalMessage(error.response?.data?.error || 'Submission failed');
      setShowResultModal(true);
      setSubmissionSuccess(false);
    }
  };

  const handleResultModalClose = () => {
    setShowResultModal(false);

    if (submissionSuccess){
      navigate('/leaderboard');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top after route change
      }, 50); // Delay to ensure the new page is rendered
    }
  };


  return (
<div className="py-8 min-h-screen text-white">
<h2 className="text-2xl font-bold text-center mb-4 py-3">Forge Your Seed!</h2>
  <div className="col-span-3 text-center">
    <div className="">
      <label className="block mr-4 text-sm text-gray-300" htmlFor="seed">
        CURRENT SEED
      </label>
      <SeedInput value={seed} onChange={handleManualSeedChange} pasteMode={true} />
    </div>
  </div>
  <form className="rounded-lg max-w-6xl mx-auto p-6 space-y-8">
    {/* Section 1: Tag Input and Character Selection */}
    <div className="flex flex-col md:flex-row items-center gap-6">
  <div className="flex-grow md:flex-1 bg-gray-950/50 px-4 py-3 border border-pink-300/30 rounded-lg"> 
  <ErrorMessage message={tagError}/>
    <div className="flex flex-col md:flex-row items-center gap-4 lg:gap-16">
      <div>
        <label className="block mb-5" htmlFor="tag">
          Tag
        </label>
        <input
          className="appearance-none block w-full text-gray-200 bg-pink-100/10 rounded-lg py-2 px-4 leading-tight focus:outline-none focus:ring ring-pink-300/30"
          id="tag"
          type="text"
          placeholder="The name of your bot"
          value={tag}
          onChange={handleTagInput}
        />
      </div>

      <div>
       <label className="block mb-2" htmlFor="tag">
          Character
        </label>
        <CharacterSelect characters={characters} onSelectCharacter={handleCharacterSelectFromHUD} selectedCharacter={selectedCharacter} />
      </div>
    </div>
  </div>
  <div className="flex flex-col justify-end">
    <div className="flex justify-right block mb-2">
    <button
      type="button"
      onClick={randomize}
      className="block px-3 py-3 bg-gradient-to-br from-blue-400/20 via-purple-400/20 to-pink-400/20 border border-pink-300/40 rounded-lg hover:border-animate-hue-rotate hover:animate-hue-rotate focus:outline-none focus:ring-2 focus:ring-pink-300/50 transition-all duration-300 hover:border-pink-300/90"
      >
        Randomize
      </button>
    </div>
    {/*<div className="flex justify-right block mb-2">
      <LiveBots liveBots={liveBots} onSelect={handlePresetSelect} selected={selectedPreset} defaultName="Presets" />
    </div>
  */}
  </div>
</div>

    {/* Section 2: Costume Selection */}
    {selectedCharacter && (
      <div className="bg-gray-950/50 px-4 py-3 border border-pink-300/30 rounded-lg">
        <CostumeSelect
          costumes={costumes}
          onSelectCostume={handleCostumeSelect}
          selectedCostumeId={selectedCostumeId}
        />
      </div>
    )}

    {/* Section 3: Stage Selection */}
    <HelpingBubble description="Your bot will play and learn on this stage more often">
    <div className="bg-gray-950/50 px-4 py-3 border border-pink-300/30 rounded-lg">
      <StageSelect
        onSelectStage={handleStageSelect}
        selectedStageId={selectedStageId}
      />
    </div>
    </HelpingBubble>

    {/* Section 4: Stat Allocation */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
      <div className="grid grid-rows-1 gap-6 items-center">
        {/* Left: Sliders */}
        <div className="bg-gray-950/50 px-8 py-3 border border-pink-300/30 rounded-lg">
          <StatsAllocator stats={stats} onSliderChange={handleSliderChange} />
        {/* Reset Button */}
        <div className="col-span-full flex justify-center mt-4">
          <button
            type="button"
            onClick={handleResetStats}
            className="px-4 py-2 border border-pink-300/30 rounded-lg hover:border-pink-300 focus:outline-none duration-200 ease-in-out"
          >
            Reset
          </button>
        </div>
        </div>
        {/* Preferred move */}
         {/*Coaching bot*/}
        <div className="grid grid-cols-1 lg:grid-cols-2 bg-gray-950/50 px-8 py-3 border border-pink-300/30 rounded-lg">
          <HelpingBubble description="Encourages the bot to include this move in its playstyle.">
          <MoveSelect moves={moves} onSelectMove={handleMoveSelect} selectedMoveId={selectedMoveId} />
          </HelpingBubble>
          <HelpingBubble description="Speeds up early training by progressively distilling the coach's knowledge, helping your bot learn faster by mimicking its playstyle.">
          <div className="col-span-1">
            <p>Coach</p>
            <div className="py-2">
              <LiveBots liveBots={liveBots} onSelect={handleCoachSelect} selected={selectedCoach} defaultName="None" />
            </div>
          </div>
          </HelpingBubble>
        </div>

      </div>

      {/* Right: Radar Plot */}
      <div className="bg-gray-950/50 border border-pink-300/30 rounded-lg flex justify-center items-center">
        <div className="p-1 rounded-lg shadow-lg max-w-xl mx-auto">
        <h3 className="text-lg font-bold text-gray-100 text-center mt-2">
          Stats
        </h3>
        <StyledRadarChart stats={stats} />
        </div>
      </div>
    </div>

    {/* Submit Button */}
    <div className="flex justify-center">
    <button
      type="button"
      onClick={() => {setShowConfirmModal(true)}}
      disabled={!isValid}
      className={`block px-5 py-3 rounded-lg font-semibold focus:outline-none transition-all duration-50 ${
        !isValid
          ? 'cursor-not-allowed' // Disabled styles
          : 'hover:scale-105' // Enabled styles
      }`}
    >
      <img
        src="/misc/GO.webp"
        alt=""
        className={`w-32 object-contain inline ${
          !isValid ? 'opacity-25' :  'opacity-100 ' }`}
      />
    </button>
    </div>
  </form>
  {showConfirmModal && <ConfirmationModal message={confirmationModalMessage} onConfirm={handleSubmit} onCancel={() => {setShowConfirmModal(false)}} />}
  {showResultModal && <AlertModal message={resultModalMessage} onClose={handleResultModalClose} success={submissionSuccess} />}
</div>
  );
};

export default BotSubmissionForm;
